import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private sentryHandler = Sentry.createErrorHandler();

  handleError(error: unknown): void {
    if (Sentry.isInitialized()) {
      this.sentryHandler.handleError(error);
    } else {
      console.error('[GlobalErrorHandler] Sentry not initialized, logging to console:', error);
    }
  }
}